import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row h-full w-full px-4 md:mx-0 pt-6 xl:pt-[88px] pb-6 overflow-y-auto no-scrollbar gap-6 md:justify-center" }

import TarotCalculatorCard from "@/views/Calculators/TarotPrediction/components/TarotCalculatorCard.vue";
import { useI18n } from "vue-i18n";
import { ROUTE_NAMES } from "@/constants/routeNames";
import PageTitleWithBackButton from "@/components/PageTitleWithBackButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TarotPredictionView',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleWithBackButton, {
      "page-title": _unref(t)('calculators.tarot.title'),
      "title-align": 'center',
      class: "md:hidden !mb-0"
    }, null, 8, ["page-title"]),
    _createVNode(TarotCalculatorCard, {
      "card-title": _unref(t)('calculators.tarot.daily-card.title'),
      "card-text": _unref(t)('calculators.tarot.daily-card.description'),
      "calculator-route": _unref(ROUTE_NAMES).TAROT_DAILY
    }, null, 8, ["card-title", "card-text", "calculator-route"]),
    _createVNode(TarotCalculatorCard, {
      "card-title": _unref(t)('calculators.tarot.situation-prediction.title'),
      "card-text": _unref(t)('calculators.tarot.situation-prediction.description'),
      "calculator-route": _unref(ROUTE_NAMES).TAROT_SITUATION
    }, null, 8, ["card-title", "card-text", "calculator-route"])
  ]))
}
}

})